// tutoruuAPI.js
import API from 'portapi-helper';

const server = "https://api.tutoruu.com/api/";
export default new API(server);

